import { UserDTO } from '@envclient/envcore';
import Player, { Color } from './Player';
import { Inject, Property, Type } from '@dipscope/type-manager';
import 'reflect-metadata';
import logger from '../logger';

@Type({ injectable: true })
class PlayerList<P extends Player = Player> {
  @Property([Player])
  private _players: Player[] = [];

  get players(): P[] {
    return this._players as P[];
  }

  @Property()
  private _actPlayer: Player;
  get actPlayer(): P {
    return this._actPlayer as P;
  }

  public playerType: { new (): P };

  // player type class is passed as constructor param
  //to make generic instantiation possible.
  constructor(/*@Inject('playerType') playerType: { new (): P }*/) {
    // this.playerType = playerType;
    logger.info('new PlayerList');
  }

  colors: Color[] = [Color.BLUE, Color.RED, Color.YELLOW, Color.ORANGE, Color.GREY];

  addPlayer(user: UserDTO): P {
    if (this.containsClientId(user.userId)) return null;
    const player: P = new this.playerType();
    player.id = user.userId;
    player.displayName = user.displayName;
    player.color = this.generateColor();
    this.players.push(player);
    return player;
  }

  removePlayer(clientId: number): P {
    if (!this.containsClientId(clientId)) return null;
    const player = this.playerById(clientId);
    this.players.splice(this.players.findIndex((p) => p.id === clientId));
    this.returnColor(player.color);
    return player;
  }

  generateColor(): Color {
    const index = Math.floor(Math.random() * this.colors.length);
    return this.colors.splice(index, 1)[0];
  }

  returnColor(color: Color) {
    if (this.colors.includes(color)) return;
    this.colors.push(color);
  }

  /**
   * Can be called by user action (i.e. submit) or timeout
   */
  nextPlayer(): P {
    if (this.players.length == 0) return null;

    if (this.actPlayer == null) {
      this._actPlayer = this.players[0];
    } else {
      let index = this.players.indexOf(this.actPlayer) + 1;
      if (index >= this.players.length) index = 0;
      this._actPlayer = this.players[index];
    }
    return this.actPlayer as P;
  }

  playerById(clientId: number): P {
    return this.players.find((p) => p.id === clientId) as P;
  }

  // *************** private

  private containsClientId(clientId: number): boolean {
    return !!this.players.find((p) => p.id == clientId);
  }
}

export default PlayerList;
